import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, Fragment } from "react";
import { ListItemText, ListItem, ListSubheader, Typography, Paper } from "@material-ui/core";
import List from "@material-ui/core/List";
import { useFormikContext, getIn } from "formik";
import { isNotNull } from "@ploy-lib/calculation";
import { usePages } from "../pagesContext";
import { usePageState } from "../PageContext";
import { isNotLiteral, mapToPaths } from "../utils";
import { getFieldName } from "@ploy-lib/core";
import { useTemplateFieldIsVisible, useTemplateSectionIsVisible } from "../hooks";
export function FormErrors(props) {
    const { elevation, ...rest } = props;
    const { touched, errors } = useFormikContext();
    const { step, goto } = usePageState();
    const pages = usePages();
    const fieldIsVisible = useTemplateFieldIsVisible();
    const sectionIsVisible = useTemplateSectionIsVisible();
    const activePageFields = useMemo(() => new Map(Object.values(pages[step].panels)
        .filter(isNotLiteral)
        .flatMap(panel => panel.sections || [])
        .filter(isNotLiteral)
        .filter(sectionIsVisible)
        .flatMap(section => section.fields)
        .filter(isNotLiteral)
        .filter(fieldIsVisible)
        .map(field => [getFieldName(field), field])), [fieldIsVisible, sectionIsVisible, pages, step]);
    const allFieldsWithStep = useMemo(() => {
        const fieldsWithStep = pages.flatMap((page, i) => Object.values(page.panels)
            .filter(isNotLiteral)
            .flatMap(panel => panel.sections || [])
            .filter(isNotLiteral)
            .flatMap(section => section.fields)
            .filter(isNotLiteral)
            .map(field => ({ field, fieldStep: i })));
        return new Map(fieldsWithStep.map(fieldWithStep => [getFieldName(fieldWithStep.field), fieldWithStep]));
    }, [pages]);
    const formErrorsToDisplay = useMemo(() => {
        return mapToPaths(touched)
            .map(path => {
            if (activePageFields.has(path))
                return null;
            const fieldWithStep = allFieldsWithStep.get(path);
            if (!fieldWithStep)
                return null;
            const { field, fieldStep } = fieldWithStep;
            if (!fieldIsVisible(field) || fieldStep > step)
                return null;
            const message = getIn(errors, path);
            if (!message)
                return null;
            const label = field.label ? field.label : path;
            return { message, label, path, fieldStep };
        })
            .filter(isNotNull)
            .reduce((acc, item) => {
            acc[item.fieldStep] = acc[item.fieldStep]
                ? [...acc[item.fieldStep], item]
                : [item];
            return acc;
        }, {});
    }, [
        activePageFields,
        allFieldsWithStep,
        errors,
        fieldIsVisible,
        step,
        touched
    ]);
    const entries = Object.entries(formErrorsToDisplay);
    return entries.length === 0 ? null : (_jsx(Paper, { square: true, elevation: elevation, children: _jsx(List, { dense: true, ...rest, children: entries.map(([stepKey, items]) => (_jsxs(Fragment, { children: [_jsx(ListSubheader, { children: pages[stepKey].label }), items.map(({ label, message, path, fieldStep }) => (_jsxs(ListItem, { button: true, onClick: () => goto(fieldStep), children: [_jsx(ListItemText, { primary: message, primaryTypographyProps: { color: "error" } }), _jsx(Typography, { children: label })] }, path)))] }, stepKey))) }) }));
}
FormErrors.displayName = "DployFormErrors";
export default FormErrors;
//# sourceMappingURL=FormErrors.js.map